import { useState, useEffect } from "react";

const initalPagination = { pageStart: 0, limit: 10 };

const useFilters = () => {

  const [search, setSearch] = useState(null);
  const [sort, setSort] = useState(null);
  const [debouncedValue, setDebouncedValue] = useState(search);
  const [pagination, setPagination] = useState(initalPagination);

  useEffect(() => {

    const handler = setTimeout(() => {
      setPagination(initalPagination);
      setDebouncedValue(search);
    }, 1000);

    return () => clearTimeout(handler);

  }, [search]);

  const onChange = (e) => {
    setSearch(e != "" ? e : null);
  };

  const onChangeSort = (e) => {
    setSort(e != "" ? e : null);
  };

  const handlePageChange = (currentPage, pageSize) => {
    setPagination({ pageStart: currentPage, limit: pageSize });
  };

  return {
    search,
    sort,
    debouncedValue,
    pagination,
    onChange,
    onChangeSort,
    handlePageChange,
  };
};

export default useFilters;
